import React, { useMemo } from 'react';
import { Select } from '../select';
import { components } from 'react-select';
import { Items } from '../items';
const Menu = (props) => {
    const isSelected = (item) => { var _a; return item.id === ((_a = props.getValue()[0]) === null || _a === void 0 ? void 0 : _a.id); };
    return (React.createElement(components.Menu, { ...props },
        React.createElement(Items, { items: props.options, onItemClick: props.selectOption, checkSelection: isSelected })));
};
const customComponents = { Menu };
const customStyles = {
    dropdownIndicator: (provided, { isDisabled }) => {
        return {
            ...provided,
            display: isDisabled ? 'none' : provided.display
        };
    }
};
export const MobileMode = ({ items, disabled, checkSelection, onItemClick }) => {
    const options = useMemo(() => items.map((item) => ({ ...item, value: item.id, label: item.title })), [items]);
    const currentValue = useMemo(() => {
        const flatOptions = options.reduce((acc, option) => {
            if (option.children) {
                return [
                    ...acc,
                    ...option.children.map((item) => ({ ...item, value: item.id, label: item.title }))
                ];
            }
            else {
                acc.push(option);
                return acc;
            }
        }, []);
        return checkSelection && flatOptions.find(checkSelection);
    }, [options, checkSelection]);
    return (React.createElement(Select, { options: options, components: customComponents, styles: customStyles, onChange: onItemClick, value: currentValue, disabled: disabled, maxMenuHeight: "60vh", isSearchable: false }));
};
